(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/mini-cart.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/mini-cart.js');
"use strict";


const MAX_TICKETS = svs.tickets_giftshop.constants.cart.MAX_TICKETS;
const animations = svs.tickets_giftshop.products.animations;
const MiniCart = _ref => {
  let branding = _ref.branding,
    productCount = _ref.productCount;
  const CartIcon = svs.ui.ReactIcon;
  const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  const isFirstRender = React.useRef(true);
  const countEl = React.useRef(null);
  const handleCartClick = e => {
    const target = document.getElementById('tg-cart');
    if (target.scrollIntoView) {
      e && e.preventDefault();
      target.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  React.useEffect(() => {
    if (isFirstRender.current) {
      animations.miniCartOnRenderBounce(countEl.current, {
        delay: 1.4
      });
      isFirstRender.current = false;
      return;
    }
    const a = animations.miniCartBounce(countEl.current);
    !a.isActive() && a.play();
  }, [productCount]);
  if (isNaN(productCount)) {
    return null;
  }
  return React.createElement("div", {
    className: "tg-mini-cart tg-mini-cart-".concat(branding || 'default', " ").concat(isLoggedIn ? 'tg-mini-cart-logged-in-top' : 'tg-mini-cart-default-top'),
    ref: countEl
  }, React.createElement("a", {
    className: "align-center block",
    href: "#tg-cart",
    onClick: handleCartClick
  }, React.createElement(CartIcon, {
    className: "block",
    icon: "game-package",
    size: "100"
  }), React.createElement("div", null, productCount, "/", MAX_TICKETS)));
};
const mapState = state => {
  const branding = state.settings.branding;
  const cart = state.cart[branding] || {};
  return {
    productCount: cart.count || 0,
    branding
  };
};
svs.tickets_giftshop.gift.components.MiniCart = ReactRedux.connect(mapState)(MiniCart);

 })(window);